export const HOME = '/';
export const WRITERS = '/writers';
export const WRITER = '/writer';
export const SIGN_IN = '/signin';
